import React from 'react';
import {Row, Col} from 'antd';

class App extends React.Component {
  render() {
    const fullScreen = true;
    return (
      // <Row style={{backgroundColor: '#f0f4f8',padding: '83px 0 25px 0'}}>
      //   <Col span={20} offset={2}>{this.props.children}</Col>
      // </Row>
      <div style={fullScreen ? {} : {padding: '71px 0 65px 0'}}>
        <Row>
          <Col span={24}>
            {this.props.children}
          </Col>
        </Row>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/util/AppDatasBody.js